/* eslint-disable */
export default {
  region: 'Alue',
  calling: 'Puhelut',
  logout: 'Kirjaudu ulos',
  version: 'Versio',
  settings: 'Asetukset',
  selectToDialSMS: 'Valitse, kun haluat soittaa / lähettää SMS:n',
  selectToDial: 'Valitse, kun haluat soittaa',
  selectToSMS: 'Valitse, kun haluat lähettää SMS:n',
  clickToDial: 'Valitse napsauttamalla',
  autoCreateLog: 'Luo puheluloki automaattisesti',
  autoCreateSMSLog: 'Luo SMS-loki automaattisesti',
  autoLogCalls: 'Lisää puhelut lokiin automaattisesti',
  autoLogNotes: 'Lisää muistiinpanot lokiin automaattisesti',
  autoLogSMS: 'Lisää SMS:t lokiin automaattisesti',
  clickToSMS: 'Lähetä SMS klikkaamalla',
  logSMSContent: 'Lisää SMS-sisältö lokiin',
  clickToDialSMS: 'Valitse/lähetä SMS napsauttamalla',
  logExtensionCall: 'Kirjaa alanumeron puhelut',
  audio: 'Ääni',
  language: 'Kieli',
  feedback: 'Palaute',
  userGuide: 'Uutta',
  quickAccess: 'Pikakäyttöasetukset',
  report: 'Analytics-raportti',
  shareIdea: 'Jaa idea',
  openEntityFrom: 'Salesforce-kohteen toiminta',
  ctiPanelSize: 'CTI-paneelin koko',
  openInNewTab: 'Avaa uudessa välilehdessä',
  openInCurrentTab: 'Avaa nykyisessä välilehdessä',
  reportIssue: 'Ilmoita ongelmasta',
  contactSupport: 'Ota yhteyttä tukeen',
  selectToDialHint:
    'Saat paremman kokemuksen valitsemalla puhelinnumeron, johon soitetaan RingCentralin kautta suurella puhelinnumerosivulla.',
} as const;

// @key: @#@"region"@#@ @source: @#@"Region"@#@
// @key: @#@"calling"@#@ @source: @#@"Calling"@#@
// @key: @#@"logout"@#@ @source: @#@"Logout"@#@
// @key: @#@"version"@#@ @source: @#@"Version"@#@
// @key: @#@"settings"@#@ @source: @#@"Settings"@#@
// @key: @#@"selectToDialSMS"@#@ @source: @#@"Select to Dial/SMS"@#@
// @key: @#@"selectToDial"@#@ @source: @#@"Select to Dial"@#@
// @key: @#@"selectToSMS"@#@ @source: @#@"Select to SMS"@#@
// @key: @#@"clickToDial"@#@ @source: @#@"Click to Dial"@#@
// @key: @#@"autoCreateLog"@#@ @source: @#@"Auto-create Call Log"@#@
// @key: @#@"autoCreateSMSLog"@#@ @source: @#@"Auto-create SMS Log"@#@
// @key: @#@"autoLogCalls"@#@ @source: @#@"Auto log calls"@#@
// @key: @#@"autoLogNotes"@#@ @source: @#@"Auto log notes"@#@
// @key: @#@"autoLogSMS"@#@ @source: @#@"Auto log SMS"@#@
// @key: @#@"clickToSMS"@#@ @source: @#@"Click to SMS"@#@
// @key: @#@"logSMSContent"@#@ @source: @#@"Log SMS content"@#@
// @key: @#@"clickToDialSMS"@#@ @source: @#@"Click to Dial/SMS"@#@
// @key: @#@"logExtensionCall"@#@ @source: @#@"Log extension calls"@#@
// @key: @#@"audio"@#@ @source: @#@"Audio"@#@
// @key: @#@"language"@#@ @source: @#@"Language"@#@
// @key: @#@"feedback"@#@ @source: @#@"Feedback"@#@
// @key: @#@"userGuide"@#@ @source: @#@"What's New"@#@
// @key: @#@"quickAccess"@#@ @source: @#@"Quick Access Setting"@#@
// @key: @#@"report"@#@ @source: @#@"Analytics Report"@#@
// @key: @#@"shareIdea"@#@ @source: @#@"Share idea"@#@
// @key: @#@"openEntityFrom"@#@ @source: @#@"Salesforce object behavior"@#@
// @key: @#@"ctiPanelSize"@#@ @source: @#@"CTI panel size"@#@
// @key: @#@"openInNewTab"@#@ @source: @#@"Open in new tab"@#@
// @key: @#@"openInCurrentTab"@#@ @source: @#@"Open in current tab"@#@
// @key: @#@"reportIssue"@#@ @source: @#@"Report issue"@#@
// @key: @#@"contactSupport"@#@ @source: @#@"Contact support"@#@
// @key: @#@"selectToDialHint"@#@ @source: @#@"For your better experience, select phone number to dial with RingCentral in large quantity phone number page."@#@
